import { render, staticRenderFns } from "./dialog-scan-epc.vue?vue&type=template&id=3b46d7a4"
import script from "./dialog-scan-epc.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-scan-epc.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports